export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-08.0e3dc326.png";